import {add, isAfter, isBefore, isEqual, isWithinInterval, differenceInCalendarDays, parse} from "date-fns";


export default class Time {


    static getCurrentYear() {
        return new Date().getFullYear();
    }

    static getCurrentMonth() {
        return new Date().getMonth();
    }

    static getMonthDateRange(year, month) {
        const nextMonth = new Date(parseInt(year, 10), parseInt(month, 10)+1);
        const endDate = this.addTimeToDuration(nextMonth, {days: -1}); //Next month - 1 day
        const startDate = new Date(parseInt(year, 10), parseInt(month, 10),1);
        return [this.stringifyDate(startDate), this.stringifyDate(endDate)];
    }

    static parseDate(dateStr) {
        return parse(dateStr, "yyyy-MM-dd", new Date());
    }

    static parseDateFromTimestamp(timestamp) {
        return parse(timestamp, "t", new Date());
    }

    static stringifyDate(date) {
        const month = date.getMonth() + 1;
        let monthStr = "" + month;
        if (month < 10) {
            monthStr = "0" + month;
        }
        let dayStr = "" + date.getDate();
        if (date.getDate() < 10) {
            dayStr = "0" + date.getDate();
        }
        return date.getFullYear() + "-" + monthStr + "-" + dayStr;
    }

    static addTimeToDuration(time, duration) {
        return add(time, duration);
    }

    static isNowWithinRange(startDate, endDate) {
        return this.isWithinRange(new Date(), [this.parseDate(startDate), this.parseDate(endDate)]);
    }

    static isWithinRange(date, range) {
        return isWithinInterval(date, { start: range[0], end: range[1] });
    }

    static isWithinRanges(date, ranges) {
        return ranges.some(range => this.isWithinRange(date, range));
    }

    static rangesOverlap(firstStart, firstEnd, secondStart, secondEnd) {
        if (isEqual(firstStart, secondStart) ||
            isEqual(firstStart, secondEnd) ||
            isEqual(firstEnd, secondStart) ||
            isEqual(firstEnd, secondEnd))
        {
            // share a date
            return true;
        } else if (isAfter(firstStart, secondStart) && isBefore(firstStart, secondEnd)) {
            // start is inside
            return true;
        } else if (isAfter(firstEnd, secondStart) && isBefore(firstEnd, secondEnd)) {
            // end is inside
            return true;
        } else if (isBefore(firstStart, secondStart) && isAfter(firstEnd, secondEnd)) {
            // covers
            return true;
        }
        return false;
    }

    static calculateDifferenceInDaysBetweenInclusive(date1, date2) {
        if (isAfter(date1, date2)) {
            return differenceInCalendarDays(date1, date2) + 1; //+1 here to include the 1/2 day on each side for inclusive
        }
        return differenceInCalendarDays(date2, date1) + 1;
    }

}